module.exports = __webpack_public_path__ + "assets/xue.239f6f30.svg";